import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";

const sprintf = require("sprintf-js").sprintf;

@Pipe({
  name: 'kompaktAmtNummer'
})
export class KompaktAmtnummerPipe extends KompaktdarstellungPipe<number> {

  constructor(protected formatConfigService: FormatConfigService, protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy) {
    super(formatConfigService, 'AMTNUMMER', location, kompaktLocation);
  }

  transform(nummer: number): string {
    if (this.formatElement === 'AMTNUMMER_OHNE' || !nummer) {
      return '';
    }
    return sprintf('%03d-', nummer);
  }
}
